// src/auth/deep-link.js — a link straight to a screen in the staff app (v132.65).
//
// Matt, 26 Sep 2026: "once finished i want the paper with links to the training
// etc. in it". The staff app had no way to be opened AT a screen: every tab was
// reached by a button after login, so a document could only say "open Shift,
// then tap Training". Now https://elcapp-shift.netlify.app/?screen=training
// lands the person on Training once they are in, and the paper, a news post
// or a task can carry that link.
//
// WHITELISTED, NOT TRUSTED. The value comes from a URL anyone can type. It is
// matched against the fixed list of real screen names and anything else is
// ignored, so a stray or malicious parameter can never call into the app with
// an unexpected string. It is also only ever a SCREEN NAME handed to
// switchScreen, never markup, never a selector.
//
// Pure, so the rule is tested without a browser.

export const DEEP_LINK_SCREENS = [
  'awards', 'bonus', 'calls', 'chat', 'checklist', 'clock', 'contacts', 'customer',
  'email', 'eod', 'feedback', 'jack', 'kpi', 'links', 'news', 'pettycash', 'requests', 'rota', 'tasks',
  'today', 'toil', 'training', 'updates',
];

// v136.3 - ?rotastore=NAME: the admin app's Store rotas page ("Edit in the staff app") opens the staff app at that
// store's rota. The store is honoured ONLY when it is one the signed-in person may already pick (getMyStores, the
// same list as the store dropdowns), and only after sign-in (startApp); anything else is ignored. Exact match, never
// trimmed or normalised: staff.store is a string FK to stores.name. It changes which of YOUR stores is on screen and
// nothing else, so it can never widen what anyone sees.
//
// Why not ?store=: db.js's withBootHint already reads ?store= from the page address as the per-tenant boot hint and
// appends it to EVERY Worker call that does not name a store, and ~60 routes read ?store= as a filter. A rota link
// named ?store= would quietly re-scope the whole staff app's reads to one store.
export function rotaStoreFromSearch(search, myStores) {
  let v = null;
  try {
    v = new URLSearchParams(String(search == null ? '' : search)).get('rotastore');
  } catch (e) { return null; }
  if (!v) return null;
  const list = Array.isArray(myStores) ? myStores : [];
  return list.indexOf(v) >= 0 ? v : null;
}

// The screen named by ?screen=, or null when absent or not a real screen.
export function screenFromSearch(search, allowed) {
  const list = Array.isArray(allowed) ? allowed : DEEP_LINK_SCREENS;
  let v = null;
  try {
    v = new URLSearchParams(String(search == null ? '' : search)).get('screen');
  } catch (e) { return null; }
  if (!v) return null;
  const name = String(v).trim().toLowerCase();
  return list.indexOf(name) >= 0 ? name : null;
}
